import PageLayout from "../../components/layout/page";
import UnMountingReportList from "./unMountingReport";

export default function UnMountingReport() {
    return (
        <PageLayout className="dashboard-inner-page"
            View={
                <>
                    <UnMountingReportList />
                </>
            }
        />
    );
}
export {}